import React from 'react';
import { PrimaryButton } from '@gje/buttons';
import { getText } from '../../../../../services/text/text-service';
import { Title } from '@gje/typography/lib';
import { ExpandableBulletText } from '../../../../components/ExpandableBulletText/ExpandableBulletText';
import uuid from 'uuid';
import { resolvePaymentTerm } from '../../../../../services/calculation-data/calculation-data-service';
import { numberWithSpaces } from '../../../../../utils/stringUtils';
import classNames from 'classnames';
import { getPrice, resolveQuestion } from './CoverageDetails';

const selectedCardImage = require('../../../../../images/selectedCard.png');

export const CoverageDetailsDesktop = props => {
    let detailsWidth = (23 * (1 / 3) * 100) / 23;
    let coveragesWidth = (23 * (2 / 3) * 100) / 23;
    let margin = coveragesWidth * 0.01;
    let columnWidth = coveragesWidth / props.coverages.length - margin;

    const styles = {
        width: `${columnWidth}%`
    };

    const handleClick = (e, index) => {
        props.setSelectedIndex(index);
        props.setSelectedCoverage(e.currentTarget.value);
    };

    const renderCoverageDetailsRows = () => {
        let coverages = props.coveragesConfig.coverages;
        return props.coveragesConfig.coveragesDetails.map(value => {
            let cols = props.coverages.map((coverage, index) => {
                return (
                    <div
                        key={uuid.v4()}
                        style={{
                            ...styles,
                            marginRight: `${
                                index === props.coverages.length - 1
                                    ? ''
                                    : margin
                            }%`
                        }}
                        className={`background-color-${
                            coverages[coverage.coverageProduct].color
                        } 
                       padding-5 text-center float-left coverage-details-column border-bottom-2-white`}>
                        <div className={'min-height-20 font-size-20'}>
                            {resolveQuestion(
                                value[`${coverage.coverageProduct}`]
                            )}
                        </div>
                    </div>
                );
            });
            return (
                <div key={uuid.v4()} className={`row display-flex`}>
                    <div
                        style={{
                            width: `${detailsWidth}%`,
                            marginRight: `${margin}%`
                        }}
                        className={`text-align-left float-left align-self padding-5 padding-left-25`}>
                        <ExpandableBulletText
                            text={value.coverageDesc}
                            helpText={value.coverageSubDesc}
                            arrowSize={14}
                        />
                    </div>
                    {cols}
                </div>
            );
        });
    };

    const renderArrow = shouldRender => {
        return (
            <div
                className={classNames('selected-cover-image-container', {
                    'visibility-hidden': !shouldRender
                })}>
                <img
                    className="selected-cover-image"
                    src={selectedCardImage}
                    alt="selected-insurance-img"
                />
            </div>
        );
    };

    const renderHeadersRows = () => {
        let names = props.coverages.map((value, index) => {
            let cover = props.coveragesConfig.coverages[value.coverageProduct];
            return (
                <div
                    key={uuid.v4()}
                    style={{
                        ...styles,
                        marginRight: `${
                            index === props.coverages.length - 1 ? '' : margin
                        }%`
                    }}
                    className={`coverage-name-padding float-left background-color-${cover.color}`}>
                    {renderArrow(props.selectedIndex === index)}
                    <h1>{cover.name}</h1>
                </div>
            );
        });

        let prices = props.coverages.map((value, index) => {
            let cover = props.coveragesConfig.coverages[value.coverageProduct];
            return (
                <div
                    key={uuid.v4()}
                    style={{
                        ...styles,
                        marginRight: `${
                            index === props.coverages.length - 1 ? '' : margin
                        }%`
                    }}
                    className={`padding-5 float-left background-color-${cover.color} font-size-20`}>
                    <h2 className={'font-size-35'}>
                        {numberWithSpaces(
                            getPrice(value.coverageProduct, props.coverages)
                        )}
                    </h2>
                    <h3>
                        {resolvePaymentTerm(props.paymentTerm, value.price)}
                    </h3>
                </div>
            );
        });

        let buttons = props.coverages.map((value, index) => {
            let cover = props.coveragesConfig.coverages[value.coverageProduct];
            return (
                <div
                    key={uuid.v4()}
                    style={{
                        ...styles,
                        marginRight: `${
                            index === props.coverages.length - 1 ? '' : margin
                        }%`
                    }}
                    className={`padding-top-25 float-left background-color-${cover.color}`}>
                    <PrimaryButton
                        borderColor={'red'}
                        flexible={true}
                        value={value.coverageProduct}
                        id={`selector-radio-${cover.name}`}
                        name={cover.name}
                        className={`${
                            props.selectedIndex === index
                                ? 'visibility-hidden'
                                : ''
                        }`}
                        onClick={e => handleClick(e, index)}>
                        <div className={'display-inline-flex align-items'}>
                            <Title
                                tag={'h4'}
                                children={getText(
                                    'webshopsweden.common.cardButton'
                                )}
                            />
                        </div>
                    </PrimaryButton>
                </div>
            );
        });

        return (
            <>
                <div className={`row text-center ${props.className}`}>
                    <div
                        style={{
                            width: `${detailsWidth}%`,
                            marginRight: `${margin}%`
                        }}
                        className={'text-align-left min-height-10 float-left'}
                    />
                    {names}
                </div>
                <div
                    className={`row text-center display-flex ${props.className}`}>
                    <div
                        style={{
                            width: `${detailsWidth}%`,
                            marginRight: `${margin}%`
                        }}
                        className={
                            'text-align-left align-self min-height-10 float-left'
                        }
                    />
                    {prices}
                </div>
                <div className={`row text-center ${props.className}`}>
                    <div
                        style={{
                            width: `${detailsWidth}%`,
                            marginRight: `${margin}%`
                        }}
                        className={
                            'text-align-left min-height-10 float-left padding-5 padding-top-42 padding-left-70'
                        }>
                        <Title tag="h3">Jämför innehållet</Title>
                    </div>
                    {buttons}
                </div>
            </>
        );
    };

    return (
        <div className={'margin-top-90 margin-bottom-39'}>
            <>
                {renderHeadersRows()}
                {renderCoverageDetailsRows()}
            </>
        </div>
    );
};
